import {
  SET_RESERVAS,
  SET_MIS_RESERVAS,
  SET_SLOTS_DISPONIBLES,
  SET_CANCHAS_DISPONIBILIDAD,
  SET_BLOQUEOS,
  SET_CANCHA_SELECCIONADA,
  SET_FECHA_SELECCIONADA,
  SET_SOCIOS,
  SET_LOADING_SOCIOS,
  SET_LOADING,
  SET_ERROR,
  ADD_RESERVA,
  UPDATE_RESERVA,
  DELETE_RESERVA,
} from "./reservasActions";

const reservasReducer = (state, action) => {
  switch (action.type) {
    case SET_RESERVAS:
      return {
        ...state,
        reservas: action.payload,
        loading: false,
      };

    case SET_MIS_RESERVAS:
      return {
        ...state,
        misReservas: action.payload,
        loading: false,
      };

    case SET_SOCIOS:
      return {
        ...state,
        socios: action.payload,
        loadingSocios: false,
      };

    case SET_LOADING_SOCIOS:
      return {
        ...state,
        loadingSocios: action.payload,
      };

    case SET_SLOTS_DISPONIBLES:
      return {
        ...state,
        slotsDisponibles: action.payload,
        loading: false,
      };

    case SET_CANCHAS_DISPONIBILIDAD:
      return {
        ...state,
        canchasDisponibilidad: action.payload,
        loading: false,
      };

    case SET_BLOQUEOS:
      return {
        ...state,
        bloqueos: action.payload,
        loading: false,
      };

    case SET_CANCHA_SELECCIONADA:
      return {
        ...state,
        canchaSeleccionada: action.payload,
      };

    case SET_FECHA_SELECCIONADA:
      return {
        ...state,
        fechaSeleccionada: action.payload,
      };

    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case ADD_RESERVA:
      return {
        ...state,
        reservas: state.reservas ? [...state.reservas, action.payload] : [action.payload],
        misReservas: state.misReservas ? [...state.misReservas, action.payload] : [action.payload],
      };

    case UPDATE_RESERVA:
      return {
        ...state,
        reservas: state.reservas?.map((r) =>
          r._id === action.payload._id ? action.payload : r
        ),
        misReservas: state.misReservas?.map((r) =>
          r._id === action.payload._id ? action.payload : r
        ),
      };

    case DELETE_RESERVA:
      return {
        ...state,
        reservas: state.reservas?.filter((r) => r._id !== action.payload),
        misReservas: state.misReservas?.filter((r) => r._id !== action.payload),
      };

    default:
      return state;
  }
};

export default reservasReducer;
